// extracted by mini-css-extract-plugin
export default {"answerOption":"AnswerOption_answerOption__rWaRE","answerOptionRowWithMenu":"AnswerOption_answerOptionRowWithMenu__PUV0e","answerOptionRow":"AnswerOption_answerOptionRow__CcBSN"};